<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="card-text" class="icon"></b-icon>
            <span>ผลการเคลม</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>ผลการเคลม</label>
                            <div class="field-inline">
                                <checkbox v-model="resultPass" class="mr-3" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">ผ่าน</checkbox>
                                <checkbox v-model="resultFail" class="ml-3" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">ไม่ผ่าน</checkbox>
                            </div>
                            <div class="input-error-message" v-if="errorData.claim.result.blank">โปรดระบุราคาสินค้า</div>
                        </div>
                    </div>  
                    
                    <div class="col-12">
                        <div class="field">
                            <label>หมายเหตุ</label>
                            <input type="text"
                                v-model="formData.claim.remark"
                                class="input-field"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                maxlength="100"
                                placeholder="หมายเหตุ" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';

export default {
    mixins: [ MixinThemeBoard ],
    data() {
        return {
            formData: null,
            resultPass: false,
            resultFail: false
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    watch: {
        resultPass(value) {
            this.setResultValue('pass', value);
        },
        resultFail(value) {
            this.setResultValue('fail', value);
        }
    },
    async mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.loadClaimResult();
            this.$emit('formData', this.formData);
        },
        initForm() {
            return {
                claim: {
                    result: this.loadData ? this.loadData.claim.result : '',
                    remark: this.loadData ? this.loadData.claim.remark : ''
                }
            };
        },
        loadClaimResult() {
            if (this.loadData) {
                if (this.loadData.claim.result !== '') {
                    if (this.loadData.claim.result) {
                        this.resultPass = true;
                    } else {
                        this.resultFail = true;
                    }
                }
            }
        },
        setResultValue(field, value) {
            switch (field) {
                case 'pass':
                    this.resultFail = value ? false : true;
                    break;

                case 'fail':
                    this.resultPass = value ? false : true;
                    break;
            }

            this.formData.claim.result = this.resultPass ? true : false;
        }
    }
}
</script>